import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowUpRight } from "lucide-react";
import { CLINIC } from "@/data/site";
import { Reveal } from "@/components/motion/Reveal";

export default function CTASection({
  title = "Schedule Your Consultation",
  text = "Take the first step toward a healthier heart. Book a preventive consultation with Dr. Pallavi Mishra today.",
}) {
  const waLink = `https://wa.me/${CLINIC.phoneRaw}?text=${encodeURIComponent(
    "Hello, I would like to book an appointment with Dr. Pallavi Mishra."
  )}`;

  return (
    <section data-testid="cta-section" className="relative grain overflow-hidden bg-brand-deep text-white">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.22em] font-bold text-brand mb-5">Book Appointment</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight font-light text-balance">
                {title}
              </h2>
              <p className="mt-7 text-lg text-mint/80 max-w-xl leading-relaxed">{text}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-4">
            <Reveal delay={0.1}>
              <a
                href={`tel:+${CLINIC.phoneRaw}`}
                data-testid="cta-call-btn"
                className="group flex items-center justify-between gap-4 rounded-full bg-brand hover:bg-white text-white hover:text-brand-deep px-8 py-5 transition-colors duration-300"
              >
                <span className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.16em]">
                  <Phone size={18} /> Call {CLINIC.phone}
                </span>
                <ArrowUpRight size={20} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </Reveal>
            <Reveal delay={0.18}>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-whatsapp-btn"
                className="group flex items-center justify-between gap-4 rounded-full border border-white/25 hover:border-white text-white px-8 py-5 transition-colors duration-300"
              >
                <span className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.16em]">
                  <MessageCircle size={18} /> WhatsApp Us
                </span>
                <ArrowUpRight size={20} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </Reveal>
            <Reveal delay={0.26}>
              <Link
                to="/contact"
                data-testid="cta-contact-btn"
                className="text-center text-sm text-mint/70 hover:text-white transition-colors duration-300 mt-1"
              >
                Or use the appointment form →
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
